// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3T1z6","sendOtp":"AuthorizeToLogin_sendOtp__2CGXr"};